import React from 'react'
import './AboutUs.css'
import About from '../../assets/About.png'
import Mission from '../../assets/Mission.png'

function AboutUsCard() {
  return (
    <div className='about_container'>
      <div className="home_max_width">

        {/* Top content - with padding */}
        <div className="about_body">
          <div className="about_head">
            <h1>What We Do</h1>
            <p>About Create Tribute</p>
          </div>

          <div className="flexedCard">
            <div className="flexText">
              <h2>A place to remember, honour, and preserve the lives of those we love.</h2>
              <p>Each online memorial comes with features that enable family, friends, and love ones to digitally celebrate the life of their loved ones, by sharing the memories, tributes, and stories of those that have passed away. Creators of each memorial have full control over the memorials they create, some of the features include; About the departed, the life history, birth and death dates, the image, other gallery images of the deceased with members of the family, and a tribute song.</p>
              <p>Create Tribute is a digital memorial platform that helps families and friends come together to celebrate a life, share memories, and keep legacies alive long after the moment has passed.</p>
              <p>In a world where people are often separated by distance, we give you a space to connect, reflect, and remember together.</p>
              <p>Create Tribute is a product of Codefixbug limited, a software company located in Nigeria, its goal is to provide simplified solutions that solve problems in Nigeria, Africa, and around the world. Create Tribute is an indigenous platform, created for the greater good of preserving the legacies of people around the world.</p>
              <p>Amy Winehouse in her Back To Black song said "We only said goodbye with words", we got inspired by this to create the platform where people can come together to say goodbye to their loved ones in words, written and shared, which would bring smiles or tears to those who read the tributes and stories.</p>
            </div>
            <div className="flexImage">
              <img src={About} alt="Tribute to a love one - Createtribute" />
            </div>
          </div>
        </div>

        {/* ── OUR STORY — full width, outside about_body ── */}
        <div className="our_story_section">
          <div className="our_story_left">
            <span className="our_story_label">Our Story</span>
            <h2 className="our_story_headline">
              Families spend millions on a burial.<br />
              <em>The memory lasts a week.</em>
            </h2>
          </div>
          <div className="our_story_right">
            <p className="our_story_body">
              Create Tribute began with a moment of loss. A family grieving someone they loved wanted a way to honour that life beyond a single day and create a space where friends and relatives could share memories, send messages, and feel connected from anywhere. When it became clear there was no simple way to do this, we built one.
            </p>
            <p className="our_story_body">
              What started as a solution for one family revealed a deeper need. Many people want to preserve memories and celebrate the lives of their loved ones, but lack the tools to do it in a meaningful and lasting way. Today, Create Tribute helps families and communities come together to remember, reflect, and keep those memories alive, because <strong>every life deserves to be remembered and every memory deserves a place to live.</strong>
            </p>
          </div>
        </div>

        {/* ── WHAT WE BELIEVE — full width, outside about_body ── */}
        <div className="beliefs_section">
          <span className="beliefs_label">What We Believe</span>
          <div className="beliefs_grid">
            <div className="belief_card">
              <div className="belief_num">01</div>
              <h3 className="belief_title">Why We Exist</h3>
              <p className="belief_text">A proper burial deserves a permanent memorial. If a family will spend millions on a ceremony, the memory of that person deserves a home that outlasts it. The burial is the ceremony. The memorial is the legacy.</p>
            </div>
            <div className="belief_card">
              <div className="belief_num">02</div>
              <h3 className="belief_title">What You Can Do on Create Tribute</h3>
              <p className="belief_text">Share tributes, stories, and photos. Add a life history, a tribute song, and gallery images. Invite family and friends from anywhere in the world to contribute and celebrate together — all in one permanent space.</p>
            </div>
            <div className="belief_card">
              <div className="belief_num">03</div>
              <h3 className="belief_title">Built for Real Life, Real Culture</h3>
              <p className="belief_text">Your grandchildren will want to know who they came from. Not just a name on a grave — a voice, a face, a life history, a collection of stories from everyone who loved them. We build the place where that lives, permanently.</p>
            </div>
          </div>
        </div>

        {/* Mission - back inside padded body */}
        <div className="about_body_bottom">
          <div className="flexedCardReverse">
            <div className="flexImage">
              <h2 className='showMobile'>Our Mission Statement</h2>
              <img src={Mission} alt="Tribute to a love one - Createtribute" />
            </div>
            <div className="flexText">
              <h2 className='showDesktop'>Our Mission Statement</h2>
              <p>Our mission is to help families and friends honour life, share memories, and preserve the legacies of their loved ones through a simple and meaningful online space.</p>
              <p>We are committed to providing a place where tributes, stories, and photos can be safely shared, bringing people together even in times of loss. It is a privilege to support you and your family during moments that matter most, and to help ensure that every memory is preserved with care and respect.</p>
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}

export default AboutUsCard